import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { CARDS, CARDS_TYPE } from '../../enums/cardTypes';

export const CardCentralBox = observer(({ cardInCentralBox }) => {
  return (
    <div
      className={`${isMobile() ? 'm-' : ''}card-center-box ${
        cardInCentralBox?.cardInCentral ? '' : 'to-central-block'
      } ${cardInCentralBox?.hide ? 'hide' : ''}`}
    >
      <div className={`${isMobile() ? 'm-' : ''}card-box-inner`}>
        <div className={`${isMobile() ? 'm-' : ''}central-card-wrapper`}>
          {cardInCentralBox && (
            <div className={`${isMobile() ? 'm-' : ''}blackjack-card card-open`}>
              <div
                className={`${isMobile() ? 'm-' : ''}blackjack-card-front-side ${
                  cardInCentralBox.card === CARDS.CUTTING_CARD ? 'card-cut' : 'calode-1'
                } ${CARDS_TYPE[cardInCentralBox.card]}`}
              />
              <div
                className={`${isMobile() ? 'm-' : ''}blackjack-card-back-side ${
                  cardInCentralBox.card === CARDS.CUTTING_CARD ? 'card-cut' : 'backside-1'
                }`}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
